import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import getCustomFetchBase from '../custom-fetch-base'
import Contractor from '../../types/api/contractor'
import Strapi, { EndpointQueryParameters, StrapiCreate, StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'


export const contractorsApi = createApi({
    reducerPath: 'contractorsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Contractors'],
    endpoints: builder => ({
        getContractors: builder.query<Strapi<Contractor>, EndpointQueryParameters | void>({
            query: getQuery('/contractors'),
            providesTags: ['Contractors'],
        }),
        getMyContractors: builder.query<Strapi<Contractor>, EndpointQueryParameters | void>({
            query: getQuery('/contractors/my'),
            providesTags: ['Contractors'],
        }),
        createContractor: builder.mutation<StrapiSingle<Contractor>, StrapiCreate<Contractor>>({
            query: body => ({
                url: '/contractors',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Contractors'],
        }),
        updateContractor: builder.mutation<StrapiSingle<Contractor>, StrapiUpdate<Contractor>>({
            query: ({ docId, body }) => ({
                url: `/contractors/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Contractors'],
        }),
        deleteContractor: builder.mutation<StrapiSingle<Contractor>, StrapiUpdate<Contractor>>({
            query: docId => ({ url: `/contractors/${docId}`, method: 'DELETE' }),
            invalidatesTags: ['Contractors'],
        }),
    }),
})

export const {
    useCreateContractorMutation,
    useUpdateContractorMutation,
    useGetContractorsQuery,
    useGetMyContractorsQuery,
    useDeleteContractorMutation,
} = contractorsApi